import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputAdornment,
  Link,
  makeStyles,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from "@material-ui/core";
import bgImage from "../../constants/images/fondo.b41024b9.png";
import { CreditCard, Email, Face, Home, HomeOutlined, InsertEmoticon, Lock, TextFields } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { withAuthentication } from "../Session";
import * as ROUTES from "../../constants/routes";
import { useHistory } from "react-router-dom";
import Alert from "@material-ui/lab/Alert";
import Logo from "../../assets/logo.png";

const INITIAL_STATE = {
  name: "",
  dni: "",
  ape1: "",
  ape2: "",
  password2: "",
  password1: "",
};

const UserConfirmation = (props) => {
  const { firebase } = props;
  const { t } = useTranslation();
  const history = useHistory();

  const params = new URLSearchParams(window.location.search);
  const [error, setError] = useState(null);
  const [codeError, setCodeError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [dniError, setDniError] = useState(false);
  const [formValues, setFormValues] = useState(INITIAL_STATE);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [isCodeExpired, setIsCodeExpired] = useState(false);
  const [opensuccess, setOpensuccess] = useState(false);
  const [openError, setOpenError] = useState(false);

  const [policityOpen, setPolicityOpen] = useState(false);
  const [isProcessCompleted, setisProcessCompleted] = useState(false);
  const [policityConfirm1, setPolicityConfirm1] = useState(false);
  const [policityConfirm2, setPolicityConfirm2] = useState(false);
  const [policityCheck1, setPolicityCheck1] = useState(false);
  const [policityCheck2, setPolicityCheck2] = useState(false);
  const [policityCheck3, setPolicityCheck3] = useState(false);
  const [policityCheck4, setPolicityCheck4] = useState(false);

  const verifyPassword = () => {
    setLoading(true);
    formValues.password1 == formValues.password2 ? verifyCode() : setErrorPasswordNoMatch();
  };

  const setErrorPasswordNoMatch = () => {
    setError({ error: "passwordNotMatch", code: "paswordNotSame" });
    setPasswordError(true);
    setLoading(false);
  };

  useEffect(() => {
    /*console.log(params.get("oobCode"));
    firebase
       codigo de reseteo de password firebase 
      .verifyPasswordResetCode(params.get("oobCode"))
      .catch((error) => {
        setCodeError(true);
        console.log(error.code);
        error.code == "auth/invalid-action-code" && setIsCodeExpired(true);
        error.code == "auth/expired-action-code" && setIsCodeExpired(true);
      })
      .then((email) => {
        setEmail(email);
      });*/
  }, []);

  const verifyCode = () => {
    setPasswordError(false);
    firebase
      .verifyPasswordResetCode(params.get("oobCode") /** codigo de reseteo de password firebase */)
      .then((email) => {
        firebase
          .confirmPasswordReset(params.get("oobCode"), formValues.password1)
          .then(() => {
            firebase.doSignInWithEmailAndPassword(email, formValues.password1).then((recordUser) => {
              console.log(recordUser.user.uid);
              firebase
                .udpateUSerData(recordUser.user.uid)
                .update({
                  dni: formValues.dni,
                  name: formValues.name,
                  surname: formValues.ape1,
                  secondSurname: formValues.ape2,
                  polocityConfirmation: true,
                  autorizacion: policityCheck1,
                  comunicaciones: policityCheck3,
                })
                .then(() => {
                  setisProcessCompleted(true);
                  setTimeout(function () {
                    window.location.replace("https://www.bexencardio.com/");
                  }, 3000);
                });
            });
          })
          .catch((error) => {
            setError(error);
            setLoading(false);
          });
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  const onEmailChange = (event) => {
    setEmail(event.target.value.toLowerCase().trim());
  };
  const onChange = (event) => {
    setFormValues({
      ...formValues,
      [event.target.name]: event.target.value,
    });
  };

  const sendNewEmail = () => {
    firebase
      .sendPasswordEmail(email)
      .then(() => {
        setOpensuccess(true);
      })
      .catch((error) => {
        setOpenError(true);
      });
  };

  const checkDNI = (event) => {
    var valid = new RegExp("^[0-9]{8,8}[A-Za-z]$").test(event.target.value) || new RegExp("^[A-Za-z]{1,1}[0-9]{7,7}[A-Za-z]$").test(event.target.value);
    if (!valid) {
      setError({ error: "dniBadFormat", code: "dnibadFormat" });
      setDniError(true);
    } else {
      setDniError(false);
      setError(null);
    }
  };

  const isValid =
    formValues.name !== "" &&
    formValues.password1 !== "" &&
    formValues.password2 !== "" &&
    formValues.dni !== "" &&
    formValues.ape2 !== "" &&
    formValues.ape1 !== "" &&
    !dniError &&
    policityConfirm1 &&
    policityConfirm2;

  if (isCodeExpired) {
    return (
      <Grid
        container
        item
        xs={12}
        alignItems="center"
        justify="center"
        style={{
          minHeight: "100vh",
          //backgroundImage: `linear-gradient(180deg,rgba(167, 15, 177,.1),rgba(11, 96, 178,.1))`,
        }}
      >
        <Grid item xs={12} lg={8} container justify="center" spacing={3}>
          <Grid item xs={12} container justify="center" style={{ marginBottom: 26 }}>
            <Typography variant="h4" color="primary">
              {t("registerTitle")}
            </Typography>
          </Grid>
          <Grid item xs={12} container justify="center" style={{ marginBottom: 26 }}>
            <Typography variant="h5" color="textPrimary">
              {t("ops")}
              {t("auth/expired-action-code")}
            </Typography>
          </Grid>
          <Grid item xs={12} lg={6} container>
            <TextField
              id="email"
              variant="outlined"
              name="email"
              required
              value={email}
              onChange={onEmailChange}
              type="text"
              label={t("email")}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Email color="primary" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} lg={4} justify="center" container>
            <Button
              variant="contained"
              fullWidth
              color="primary"
              disabled={!new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$").test(email)}
              onClick={sendNewEmail}
            >
              {t("sendEmail")}
            </Button>
          </Grid>
        </Grid>
        <Snackbar
          open={opensuccess}
          autoHideDuration={6000}
          onClose={() => {
            setOpensuccess(false);
          }}
        >
          <Alert severity="success">{t("successEmailSend")}</Alert>
        </Snackbar>
        <Snackbar
          open={openError}
          autoHideDuration={6000}
          onClose={() => {
            setOpenError(false);
          }}
        >
          <Alert severity="error">{t("errorEmailSend")}</Alert>
        </Snackbar>
      </Grid>
    );
  } else {
    if (!isProcessCompleted) {
      return (
        <Grid
          container
          item
          xs={12}
          alignItems="center"
          justify="center"
          style={{
            minHeight: "100vh",
            backgroundColor: "#fafafa",
            //backgroundImage: `linear-gradient(180deg,rgba(167, 15, 177,.1),rgba(11, 96, 178,.1))`,
          }}
        >
          <Grid item xs={12} lg={6} container justify="center" spacing={3}>
            <Grid item xs={12} container>
              <Typography variant="h4" color="primary">
                {t("wellcomeRegister", { email: email })}
              </Typography>
            </Grid>
            <Paper style={{ padding: 16 }}>
              <Grid container item xs={12} justify="center">
                <Grid container item xs={12} spacing={4}>
                  <Grid item xs={12}>
                    <Typography variant="h6" color="textSecondary">
                      {t("registerTitle")}
                    </Typography>

                    <Typography variant="body2">{t("fieldsRequired")}</Typography>
                  </Grid>

                  <Grid item xs={12} lg={6} container>
                    <TextField
                      id="name"
                      variant="outlined"
                      name="name"
                      //error={error}
                      value={formValues.name}
                      onChange={onChange}
                      type="text"
                      required
                      label={t("name")}
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Face color="primary" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} lg={6} container>
                    <TextField
                      id="dni"
                      variant="outlined"
                      name="dni"
                      required
                      error={dniError}
                      value={formValues.dni}
                      onBlur={checkDNI}
                      onChange={onChange}
                      placeholder="NNNNNNNNX"
                      type="text"
                      label={t("dni")}
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <CreditCard color="primary" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} lg={6} container>
                    <TextField
                      id="appellido1"
                      variant="outlined"
                      name="ape1"
                      required
                      //error={error}
                      value={formValues.ape1}
                      onChange={onChange}
                      type="text"
                      label={t("ape1")}
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <TextFields color="primary" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} lg={6} container>
                    <TextField
                      id="apellido2"
                      variant="outlined"
                      name="ape2"
                      required
                      //error={error}
                      value={formValues.ape2}
                      onChange={onChange}
                      type="text"
                      label={t("ape2")}
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <TextFields color="primary" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} lg={6} container>
                    <TextField
                      required
                      id="password"
                      variant="outlined"
                      name="password1"
                      error={passwordError}
                      value={formValues.password1}
                      onChange={onChange}
                      type="password"
                      label={t("password")}
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Lock color="primary" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} lg={6} container>
                    <TextField
                      required
                      id="password"
                      variant="outlined"
                      name="password2"
                      error={passwordError}
                      value={formValues.password2}
                      onChange={onChange}
                      type="password"
                      label={t("repeatPassword")}
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Lock color="primary" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} container justify="center">
                    <Link href="#" onClick={() => setPolicityOpen(true)} variant="body2">
                      {t("confPolicity")}
                    </Link>
                  </Grid>
                  <Grid container item xs={12} spacing={1}>
                    <Grid item xs={12} container>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={policityCheck1}
                            onChange={() => {
                              setPolicityCheck1(!policityCheck1);
                              setPolicityCheck2(false);
                              setPolicityConfirm1(!policityCheck1 || policityCheck2);
                            }}
                          />
                        }
                        label="SI AUTORIZO el tratamiento de las imágenes a Osatu S. Coop y empresas colaboradoras del sector."
                      />
                    </Grid>
                    <Grid item xs={12} container>
                      <Typography variant="body1" color="error">
                        (*) Esta autorización es necesaria para poder llevar a cabo la formación junto con la empresa certificadora y para poder emplear el uso de sistemas de
                        Realidad Virtual
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid container item xs={12} justify="flex-start">
                    <Grid item xs={12} container>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={policityCheck3}
                            onChange={() => {
                              setPolicityCheck3(!policityCheck3);
                              setPolicityCheck4(false);
                              setPolicityConfirm2(!policityCheck3 || policityCheck4);
                            }}
                          />
                        }
                        label="Acepto recibir comunicaciones comerciales o información promocional"
                      />
                    </Grid>
                    <Grid tem xs={12} container>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={policityCheck4}
                            onChange={() => {
                              setPolicityCheck4(!policityCheck4);
                              setPolicityCheck3(false);
                              setPolicityConfirm2(policityCheck3 || !policityCheck4);
                            }}
                          />
                        }
                        label="No acepto recibir comunicaciones comerciales o información promocional "
                      />
                    </Grid>
                  </Grid>
                  {error && (
                    <Grid item xs={12} container justify="center">
                      <FormHelperText error id="my-helper-text">
                        {t(error.code)}
                      </FormHelperText>
                    </Grid>
                  )}

                  <Grid item xs={12} justify="center" container>
                    {loading ? (
                      <CircularProgress />
                    ) : (
                      <Button variant="contained" fullWidth color="primary" disabled={!isValid} onClick={verifyPassword}>
                        {t("createAccount")}
                      </Button>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Dialog open={policityOpen} onClose={() => setPolicityOpen(false)}>
            <Grid item xs={12} container>
              <DialogTitle id="alert-dialog-title">{"Política de privacidad"}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <Typography variant="body2" gutterBottom style={{ paddingBottom: 8 }}>
                    De conformidad con la normativa vigente y aplicable en protección de datos de carácter personal, le informamos que sus datos serán incorporados al sistema de
                    tratamiento titularidad de OSATU S COOP con CIF F48113161 y domicilio social sito en EDIFICIO ZEARREKOBUELTA SUBIDA DE AREITIO 5 - 48260 ERMUA (BIZKAIA), y que
                    a continuación se relacionan sus respectivas finalidades, plazos de conservación y bases legitimadoras. Para aquellos tratamientos que lo requieran, se informa
                    también de la posible elaboración de perfiles y decisiones automatizadas, así como las posibles cesiones y las transferencias internacionales que OSATU S COOP
                    tiene previsto realizar:
                  </Typography>
                  <Typography variant="body2" style={{ marginLeft: 32, marginBottom: 12 }}>
                    - Finalidad: Captación, registro y tratamiento de datos de los participantes para la gestión de las formaciones y/o cursos, expediente académico, calificaciones
                    e instancias.
                  </Typography>
                  <Typography variant="body2" style={{ marginLeft: 32, marginBottom: 12 }}>
                    - Plazo de conservación: durante el plazo estrictamente necesario para cumplir con la finalidad anteriormente mencionada.
                  </Typography>
                  <Typography variant="body2" style={{ marginLeft: 32, marginBottom: 12 }}>
                    - Base legítima: El consentimiento del interesado.
                  </Typography>
                  <Typography variant="body2" gutterBottom style={{ marginLeft: 32, marginBottom: 18 }}>
                    - Cesiones: sus datos serán comunicados en caso de ser necesario a entidades formadoras colaboradoras con la finalidad de cumplir con la inscripción e
                    impartición de las formaciones, así como la expedición de títulos. Además, se informa que la base legitimadora de la cesión es la ejecución del contrato.
                  </Typography>
                  <Typography variant="body2" style={{ marginLeft: 32, marginBottom: 12 }}>
                    - Finalidad: Gestión y tramitación de las obligaciones y deberes que se deriven del cumplimiento de la normativa a la cual está sujeta la entidad
                  </Typography>
                  <Typography variant="body2" style={{ marginLeft: 32, marginBottom: 12 }}>
                    - Plazo de conservación: conservación de las copias de los documentos hasta que prescriban las acciones para reclamarle una posible responsabilidad.
                  </Typography>
                  <Typography variant="body2" style={{ marginLeft: 32, marginBottom: 12 }}>
                    - Base legítima: El cumplimiento de una ley.
                  </Typography>
                  <Typography variant="body2" gutterBottom style={{ marginLeft: 32, marginBottom: 18 }}>
                    - Cesiones: sus datos serán comunicados en caso de ser necesario a Organismos y/o administración pública con competencia en la materia con la finalidad de
                    cumplir con las obligaciones establecidas en la normativa aplicable. Además, se informa que la base legitimadora de la cesión es el cumplimiento de una ley.
                  </Typography>
                  <Typography variant="body2" style={{ marginLeft: 32, marginBottom: 12 }}>
                    - Finalidad: Gestión administrativa, facturación, contabilidad y obligaciones legales.
                  </Typography>
                  <Typography variant="body2" style={{ marginLeft: 32, marginBottom: 12 }}>
                    - Plazo de conservación: 5 años en cumplimiento de la ley tributaria y 10 años ladocumentación fiscal en cumplimiento de la L.O. 7/2012.
                  </Typography>
                  <Typography variant="body2" style={{ marginLeft: 32, marginBottom: 12 }}>
                    - Base legítima: El cumplimiento de una ley.
                  </Typography>
                  <Typography variant="body2" style={{ marginLeft: 32, marginBottom: 12 }}>
                    - Cesiones: sus datos serán comunicados en caso de ser necesario a Agencia Tributaria,
                  </Typography>
                  <Typography variant="body2" gutterBottom style={{ marginBottom: 12 }}>
                    Bancos, Cajas y Organismos y/o administración pública con competencia en la materia con la finalidad de cumplir con las obligaciones tributarias y fiscales
                    establecidas en la normativa aplicable. Además, se informa que la base legitimadora de la cesión es el cumplimiento de una ley.
                  </Typography>
                  <Typography variant="body2" style={{ marginLeft: 32, marginBottom: 12 }}>
                    - Finalidad: Captación, registro y tratamiento de imágenes de las imágenes captadas mediante fotografías y/o videos realizados por la entidad, con la finalidad
                    de potenciar la imagen corporativa y/o promocionar las actividades de la entidad y publicarlas en la página web y/o redes sociales de la entidad
                  </Typography>
                  <Typography variant="body2" style={{ marginLeft: 32, marginBottom: 12 }}>
                    - Plazo de conservación: mientras se mantenga el consentimiento prestado.
                  </Typography>
                  <Typography variant="body2" gutterBottom style={{ marginLeft: 32, marginBottom: 18 }}>
                    - Base legítima: El consentimiento del interesado.
                  </Typography>
                  <Typography variant="body2" style={{ marginLeft: 32, marginBottom: 12 }}>
                    - Finalidad: Captación, registro y tratamiento de imágenes de las imágenes captadas mediante fotografías y/o videos realizados por la entidad, con la finalidad
                    de potenciar la imagen corporativa y/o promocionar las actividades de la entidad y publicarlas en la página web y/o redes sociales de la entidad colaboradora.
                  </Typography>
                  <Typography variant="body2" style={{ marginLeft: 32, marginBottom: 12 }}>
                    - Plazo de conservación: mientras se mantenga el consentimiento prestado.
                  </Typography>
                  <Typography variant="body2" style={{ marginLeft: 32, marginBottom: 12 }}>
                    - Base legítima: El consentimiento del interesado.
                  </Typography>
                  <Typography variant="body2" gutterBottom style={{ marginLeft: 32, marginBottom: 18 }}>
                    - Cesiones: sus datos serán comunicados en caso de ser necesario a empresas colaboradoras del sector con la finalidad de publicarlas en la página web y/o redes
                    sociales de sus entidades como ventaja por ser clientes, asociados y/o participantes de OSATU S COOP. Además, se informa que la base legitimadora de la cesión
                    es el consentimiento del interesado.
                  </Typography>
                  <Typography variant="body2" gutterBottom style={{ marginBottom: 12 }}>
                    Igualmente y de acuerdo con lo que establece la Ley 1/1982, de 5 de mayo, sobre el derecho al honor, a la intimidad personal y familiar y a la propia imagen,
                    solicitamos su consentimiento para utilizar las imágenes captadas mediante fotografías y/o videos realizados por nuestra entidad, con la finalidad anteriormente
                    mencionada.
                  </Typography>
                  <Typography variant="body2"> </Typography>
                  <Typography variant="body2" style={{ marginLeft: 32, marginBottom: 12 }}>
                    - Finalidad: Captación, registro y tratamiento de datos con finalidades de publicidad y prospección comercial
                  </Typography>
                  <Typography variant="body2" style={{ marginLeft: 32, marginBottom: 12 }}>
                    - Plazo de conservación: mientras se mantenga el consentimiento prestado.
                  </Typography>
                  <Typography variant="body2" gutterBottom style={{ marginLeft: 32, marginBottom: 18 }}>
                    - Base legítima: El consentimiento del interesado.
                  </Typography>
                  <Typography variant="body2" style={{ marginLeft: 32, marginBottom: 12 }}>
                    - Finalidad: Captación, registro y tratamiento de datos con finalidades de publicidad y prospección comercial con cesión a empresas colaboradoras del sector.
                  </Typography>
                  <Typography variant="body2" style={{ marginLeft: 32, marginBottom: 12 }}>
                    - Plazo de conservación: mientras se mantenga el consentimiento prestado.
                  </Typography>
                  <Typography variant="body2" style={{ marginLeft: 32, marginBottom: 12 }}>
                    - Base legítima: El consentimiento del interesado.
                  </Typography>
                  <Typography variant="body2" gutterBottom style={{ marginLeft: 32, marginBottom: 18 }}>
                    - Cesiones: sus datos serán comunicados en caso de ser necesario a empresas colaboradoras del sector con la finalidad de realizar publicidad, promociones de
                    servicios y prospección comercial como ventaja por ser clientes, asociados y/o participantes de OSATU S COOP. Además, se informa que la base legitimadora de la
                    cesión es el consentimiento del interesado.
                  </Typography>
                  <Typography variant="body2" gutterBottom style={{ marginBottom: 18 }}>
                    Asimismo, y de acuerdo con lo establecido en la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico, en su
                    artículo 21, solicitamos su consentimiento explícito para enviarle publicidad que consideremos puedan ser de su interés, por correo electrónico o por cualquier
                    otro medio de comunicación electrónica equivalente que usted ha proporcionado en la toma de datos:
                  </Typography>
                  <Typography variant="body2" gutterBottom style={{ marginBottom: 18 }}>
                    De acuerdo con los derechos que le confiere la normativa vigente y aplicable en protección de datos podrá ejercer los derechos de acceso, rectificación,
                    limitación de tratamiento, supresión (“derecho al olvido”), portabilidad y oposición al tratamiento de sus datos de carácter personal así como la revocación del
                    consentimiento prestado para el tratamiento de los mismos, dirigiendo su petición a la dirección postal indicada más arriba o al correo electrónico
                    info@bexencardio.com. Podrá dirigirse a la Autoridad de Control competente para presentar la reclamación que considere oportuna.
                  </Typography>
                </DialogContentText>
              </DialogContent>
            </Grid>
          </Dialog>
        </Grid>
      );
    } else {
      return (
        <Grid container item xs={12} justify="center" alignItems="center" spacing={1} style={{ minHeight: "100vh" /*backgroundImage: `url(${bgImage})`*/ }}>
          <Grid item xs={12} container spacing={2} justify="center">
            <Grid item xs={12} container justify="center" style={{ marginBottom: 18 }}>
              <img src={Logo} style={{ cursor: "pointer" }} />
            </Grid>
            <Link href="https://www.bexencardio.com/">
              <Typography variant="h3" color="primary">
                {t("registerThanks")}
              </Typography>
            </Link>
            <Link>
              <InsertEmoticon
                color="primary"
                style={{
                  fontSize: "4rem",
                  marginLeft: 8 /* color: "#fafafa" */,
                }}
              />
            </Link>
          </Grid>
        </Grid>
      );
    }
  }
};

export default withAuthentication(UserConfirmation);

const useStyles = makeStyles((theme) => ({}));
